





























import { Component, Prop, Vue } from "vue-property-decorator";
import FormElement from '@/components/common/ui/FormElement.vue';

@Component({name: 'w-input'})
export default class Input extends FormElement {
  @Prop({default: 'text'}) public type?: string;
  @Prop() public value?: string;
  @Prop() public name?: string;
  @Prop() public placeholder?: string;
  @Prop(Boolean) public disabled: Boolean;
  @Prop(Boolean) public readOnly: Boolean;
  @Prop(Boolean) public clearable: Boolean;
  @Prop(Boolean) public loading: Boolean;
  @Prop(Boolean) public autocomplete: Boolean;

  clear() {
    console.log("clear")
    this.$emit('input', null)
  }

  get getName() {
    if(this.name) {
      return this.name
    } else if (this.placeholder) {
      return this.placeholder
    }
  }
}
